import React, { Fragment } from "react";
import TableBottom from "./TableBottom";
import TableHeader from "./TableHeader";
import { connect } from "react-redux";
import { setEvaded } from "../reducers/apartments";
import * as moment from "moment";
class Table extends React.Component {
  state = {
    evaded: this.props.apartments
      .find((apartment) => apartment.name === this.props.apartmentName)
      .user.servizi.find((servizioInner) => servizioInner.id === this.props.servizio.id).evaso,
  };

  render() {
    const evaded = this.props.apartments
      .find((apartment) => apartment.name === this.props.apartmentName)
      .user.servizi.find((servizioInner) => servizioInner.id === this.props.servizio.id).evaso;
    // console.log("evaded", evaded);
    return (
      <Fragment>
        <div
          style={{
            backgroundColor: evaded ? "rgba(200, 200, 200, 0.5)" : "",
            opacity: evaded ? 0.5 : 1,
            zIndex: 200,
          }}
        >
          <Service
            servizio={this.props.servizio}
            setEvaded={this.props.setEvaded}
            apartmentName={this.props.apartmentName}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  apartments: state.apartments.data,
  loading: state.apartments.loading,
  error: state.apartments.error,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setEvaded: (apartmentName, id, value) => dispatch(setEvaded(apartmentName, id, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Table);

const Service = (props) => {
  const { servizio, setEvaded, apartmentName } = props;
  return (
    <div style={{ display: "flex", flexDirection: "column" }} id={"table"}>
      <TableHeader
        apartmentName={apartmentName}
        servizio={servizio}
        fields={typeof servizio.data[0].descrizione === "undefined"}
        length={formatRow(servizio)[0].length}
        order={servizio.id}
      />
      <TableBody servizio={servizio} />
      <TableBottom
        servizio={servizio}
        setEvaded={setEvaded}
        id={servizio.id}
        apartmentName={apartmentName}
      />
    </div>
  );
};

const TableBody = (props) => {
  const { servizio } = props;
  const total = (
    (Number(servizio.prezzo) || 0) +
    (servizio.data
      ? Array.isArray(servizio.data)
        ? servizio.data.reduce((acc, curr) => {
            return acc + Number(curr.prezzo || 0) * Number(curr.numero || 1);
          }, 0)
        : Number(servizio.data.prezzo || 0)
      : 0)
  ).toFixed(2);

  const formatted = formatRow(servizio);
  console.log('formatted: ', formatted)
  return (
    <>
      {formatted.map((row, i) => (
        <div key={`row_${i}`} style={styleLine}>
          {row.map((col, i) => (
            <Col key={`col_${i}`} {...styles(row.length)[i]}>
              {formatName(col, servizio, i === row.length - 1)}
            </Col>
          ))}
        </div>
      ))}
      <div style={styleLine}>
        <Col width={"calc(45vw - 6px)"} paddingLeft={16}>
          Totale
        </Col>
        <Col width={"6vw"} marginLeft={-1} justify={"center"}>
          {total}
        </Col>
      </div>
    </>
  );
};

const Col = (props) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: props.justify,
        height: "3.6vh",
        width: props.width,
        border: "solid",
        borderWidth: 1,
        marginLeft: props.marginLeft || 0,
        paddingLeft: props.paddingLeft || 0,
        paddingRight: props.paddingRight || 0,
      }}
    >
      {props.children}
    </div>
  );
};

const styles = (length) => {
  switch (length) {
    case 2:
      return [
        { width: "calc(15vw - 16px)", paddingLeft: 16 },
        { width: "calc(36vw - 6px)", marginLeft: -1, paddingLeft: 16 },
      ];
    case 3:
      return [
        { width: "calc(39vw - 15px)", paddingLeft: 16 },
        {
          width: "calc(6vw + 0px)",
          marginLeft: -1,
          paddingRight: 4,
          paddingLeft: 4,
          justify: "center",
        },
        { width: "calc(6vw + 0px)", marginLeft: -1, justify: "center" },
      ];
    case 4:
      return [
        { width: "calc(27vw - 15px)", paddingLeft: 16 },
        {
          width: "calc(12vw - 9px)",
          marginLeft: -1,
          paddingRight: 4,
          paddingLeft: 4,
          justify: "center",
        },
        {
          width: "calc(6vw + 0px)",
          marginLeft: -1,
          paddingRight: 4,
          paddingLeft: 4,
          justify: "center",
        },
        { width: "calc(6vw + 0px)", marginLeft: -1, justify: "center" },
      ];
    default:
      return [{}];
  }
};

const formatRow = (servizio) => {
  if (typeof servizio.data[0].descrizione !== "undefined") {
    const arr = servizio.data.map((ser, i) => {
      let rows = Object.entries(ser);
      rows = rows
       .filter((r) => !!r[1]);
      return rows;
    });
    return arr.flat();
  } else {
    return servizio.data.map((ser, i) => {
      let rows = Object.entries(ser);
      rows = rows
        .reverse()
        .slice(1)
        .reverse()
        .filter((r) => !!r[1]);
      rows = rows.map((r) => r[1]);
      return rows;
    });
  }
};

const formatName = (string, servizio, isLast) => {
  if (typeof string !== "string") {
    if (!isNaN(string) && isLast) {
      return Number(string).toFixed(2);
    }
    return string;
  } else if (string.toLowerCase().includes("tipo")) {
    return string;
  } else if (!isNaN(string)) {
    return Number(string).toFixed(2);
  } else if (moment(string).isValid()) {
    if (!servizio.data[0].ora_consegna_prevista) {
      return moment(string).format("DD/MM - hh:mm");
    } else {
      return moment(string).format("DD/MM");
    }
  } else {
    const splitted = string.split("_");
    return splitted
      .map((str) => {
        return uppercaseFirstLetter(str);
      })
      .join(" ");
  }
};

const uppercaseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const lowercaseFirstLetter = (string) => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};

const styleLine = {
  display: "flex",
  marginTop: -1,
};
